export default {
  // iconFOLDER: 'dist/assets/images/', //dev
  iconFOLDER: 'assets/images/', //prod

  templateIcons: [
    {
      url: 'A.png'
    },
    {
      url: 'B.png'
    },
    {
      url: 'C.png'
    },
    {
      url: 'D.png'
    },
    {
      url: 'iconfinder_password_4787833.svg'
    },
    {
      url: 'iconfinder_plus_4787836.svg'
    },
    {
      url: 'iconfinder_radio-disabled_4787842.svg'
    },
    {
      url: 'iconfinder_slider-horizontal_right_4787861.svg'
    },
    {
      url: 'iconfinder_text_4787855.svg'
    }
  ],
  // defaulticon:
  //   'dist/assets/images/iconfinder_004_031_upload_image_painting_photo_picture_gallery_album_1808279.svg' //dev
  defaulticon:
    'assets/images/iconfinder_004_031_upload_image_painting_photo_picture_gallery_album_1808279.svg' //prod
};
